import {
  EXCHANGE_TO_CREATE_API_KEYS_PERMISSIONS,
  PERMISSIONS_PLACEHOLDER,
  PRIMARY_EXCHANGE_TO_CREATE_API_KEYS_GUIDE,
} from "@shared/features/onboarding/constants";
import { AccountFormContext } from "@shared/features/common/AccountForm.context";
import { useContext } from "react";
import { ConfigurationExchangeInfo } from "@shared/types";

interface UseSharedConnectExchangeExtraInfoProps {
  primaryExchange?: string;
  selectedSubExchange?: ConfigurationExchangeInfo;
}

const useSharedConnectExchangeExtraInfo = ({
  primaryExchange,
  selectedSubExchange,
}: UseSharedConnectExchangeExtraInfoProps) => {
  const { selectedSubExchanges, isDemoWorkspace, exchangesData } =
    useContext(AccountFormContext)!;

  const getPermissions = () => {
    let permissionsStr = "";
    const subExchanges = selectedSubExchange
      ? [selectedSubExchange]
      : selectedSubExchanges;
    const permissionsArray = subExchanges
      ?.map(
        (subExchange) =>
          EXCHANGE_TO_CREATE_API_KEYS_PERMISSIONS[subExchange.exchange]
      )
      .filter((permission) => !!permission?.length);

    const permissions = [...new Set(permissionsArray)];
    permissions.forEach((permission, index) => {
      const separator =
        index === 0 ? "" : index === permissions?.length - 1 ? " and " : ", ";
      permissionsStr = permissionsStr.concat(separator, permission);
    });
    return permissionsStr;
  };

  const createApiKeysGuideList = primaryExchange
    ? PRIMARY_EXCHANGE_TO_CREATE_API_KEYS_GUIDE[primaryExchange]?.map(
        (item: string) =>
          item.replace(PERMISSIONS_PLACEHOLDER, getPermissions())
      )
    : [];

  return {
    createApiKeysGuideList,
    isDemoWorkspace,
    exchangesData,
  };
};

export default useSharedConnectExchangeExtraInfo;
